import React, { useEffect, useState } from "react";
import "./All_services_inner.css";
import { Link, useLocation, useParams } from "react-router-dom";
import { Nav, Tab } from "react-bootstrap";
import Video_Wala_Bus_Stand from "./Video_Wala_Bus_Stand/Video_Wala_Bus_Stand";
import Digital_Media from "./Digital_Media/Digital_Media";
import Print_Media from "./Print_Media/Print_Media";
import Branding from "./Branding/Branding";
import Multimedia_Advertising from "./Multimedia_Advertising/Multimedia_Advertising";

function All_services_inner() {
  const location = useLocation();
  const [defaultTabKey, setdefaultTabKey] = useState("Video_Wala_Bus_Stand")
  // const defaultTabKey = location.state?.tabKey || "Video_Wala_Bus_Stand"; // Default to "Advertising"

  console.log("defaultTabKey", defaultTabKey)

  const { id } = useParams();

  useEffect(() => {

    let key = ""

    if (id == 1) {
      key = "Video_Wala_Bus_Stand"
    }
    else if (id == 2) {
      key = "Multimedia_Advertising"
    }
    else if (id == 3) {
      key = "Digital_Media"
    }
    else if (id == 4) {
      key = "Print_Media"
    }
    else if (id == 5) {
      key = "Branding"
    }
    else{
      key = null
    }

    setdefaultTabKey(key)

  }, [id])

  return (
    <>
      <section className="All_services_inner">
        <div className="container">
          <div className="tab_section">

            {defaultTabKey && (
              <Tab.Container
                id="left-tabs-example"
                activeKey={defaultTabKey} // Use activeKey instead of defaultActiveKey
                onSelect={(key) => setdefaultTabKey(key)}
              >
                <div>
                  <div className="col-12">
                    <Nav variant="pills" className=" " fill>
                      <Nav.Item> 
                        <Nav.Link as={Link} to={"/services-inner/1"}  eventKey="Video_Wala_Bus_Stand">
                          Videowala Bus Stand
                        </Nav.Link>
                      </Nav.Item>

                      <Nav.Item>
                        <Nav.Link  as={Link} to={"/services-inner/2"} eventKey="Multimedia_Advertising">
                          Multimedia Advertising
                        </Nav.Link>
                      </Nav.Item>

                      <Nav.Item>
                        <Nav.Link as={Link} to={"/services-inner/3"} eventKey="Digital_Media">
                          Digital Media
                        </Nav.Link>
                      </Nav.Item>

                      {/* <Nav.Item>
                        <Nav.Link as={Link} to={"/services-inner/4"} eventKey="Print_Media">Print Media</Nav.Link>
                      </Nav.Item> */}

                      <Nav.Item>
                        <Nav.Link as={Link} to={"/services-inner/5"} eventKey="Branding">Branding</Nav.Link>
                      </Nav.Item>
                    </Nav>
                  </div>
                  <div>
                    <Tab.Content>
                      <Tab.Pane eventKey="Video_Wala_Bus_Stand">
                        <Video_Wala_Bus_Stand />
                      </Tab.Pane>

                      <Tab.Pane eventKey="Multimedia_Advertising">
                        <Multimedia_Advertising />
                      </Tab.Pane>

                      <Tab.Pane eventKey="Digital_Media">
                        <Digital_Media />
                      </Tab.Pane>

                      <Tab.Pane eventKey="Print_Media">
                        <Print_Media />
                      </Tab.Pane>

                      <Tab.Pane eventKey="Branding">
                        <Branding />
                      </Tab.Pane>
                    </Tab.Content>
                  </div>
                </div>
              </Tab.Container>
            )}


          </div>
        </div>
      </section>
    </>
  );
}

export default All_services_inner;
